import React, { useState } from "react";
import axios from 'axios'
import {useNavigate} from "react-router-dom";
import style from "./index.module.scss";
import {path} from "../../utils/const";
import Spinner from "../Spinner"

const PopupModal = (props)=> {

  const {content, approve, endconsult,toggleModal, isDocInformation, handleClick, loading} =props

  // const ChatModule = async () => {
  //   setLoading(true)
  //   try {
  //     const updates = {}
  //     updates[`/delegateChats/${delegateConvoObj?.id}/status`] = 'active'
  //     const final = await pushUpdatestoFirebase(updates)
  //
  //     setTimeout(() => {
  //       setLoading(false)
  //       toggleModal()
  //       navigate(path.activeconsultationpage, { replace: true })
  //       /* database
  //         .ref(`/delegateChats/conversationID`)
  //         .once('value', (conversationIDSnap) => {
  //           let convoID = conversationIDSnap.val()
  //           if (convoID) {
  //             toggleModal()
  //             query.set('chatId', convoID)
  //             const chatPath = path.ChatModule
  //             const paramsString = query.toString()
  //             const url = new URL(window.location.href)
  //             url.search = paramsString
  //             navigate(chatPath + url.search, { replace: true })
  //           } else {
  //             alert(
  //               'Chat can not be initiated at the moment as the patient already have an active chat, it will be started shortly!',
  //             )
  //
  //
  //           }
  //
  //         }) */
  //     }, 400)
  //   } catch (e) {
  //     setLoading(false)
  //   }
  // }

  return (
  <div className={style.modal}>
      <Spinner color="#DF7467" isLoading={loading} />
    <div>
      <span className={style.span}>{approve}</span>
    </div>
    <div>
      <p className={style.message}>{content}</p>
      <div className={style.line}></div>
      <div className={style.toggelButton}>
        <button className={style.cancelButton} onClick={toggleModal} disabled={loading}>
          {isDocInformation?"No":"Cancel"}
        </button>
        <button className={style.ApproveButton} disabled={loading} onClick={handleClick}>
          {isDocInformation?"Yes":"Approve"}
        </button>
      </div>
    </div>
  </div>
  );
}

export default PopupModal;
